import React, { useEffect } from 'react';
import GlobalLayout from 'components/Layouts/GlobalLayout';
import { analyticsWrapper } from 'analytics/itly/analyticsWrapper';
import { useTrackPageViewed } from 'analytics/itly/hooks';
import withCart from 'components/PageWrapper/withCart';
import { ContentTemplateProps } from 'types/Content';
import { ContentMetatags } from 'components/Metatags/ContentMetatags';
import { SEO } from 'components/SEO';
import DesignStylesCarousel from 'components/Diy/DesignStylesCarousel';
import './styles.css';
import BlogSchema, { BlogSchemaProps } from 'components/BlogSchema';
import TypeformQuiz from 'components/Diy/TypeformQuiz';
import ReactDOM from 'react-dom';
import Careers from 'components/Careers';
import WeddingBundles from 'components/WeddingBundles';
import { graphql, useStaticQuery } from 'gatsby';
import { Provider } from 'react-redux';
import createStore from 'store';

const WEDDING_ALBUMS_QUERY = graphql`
  query WeddingAlbumsCollection {
    productCategory(categoryId: {eq: 174}) {
      canonicalUrl
      metaDescription
      metaTitle
      products {
        addToCartLabel
        addToCartUrl
        id
        image
        metaTitle
        name
        price
        shortDescription
        sku
        urlKey
      }
      title
    }
  }
`;

const ContentPage = ({ pageContext, tracking }: ContentTemplateProps) => {
  useTrackPageViewed(tracking, 'Content Page', pageContext.title);
  const { productCategory } = useStaticQuery(WEDDING_ALBUMS_QUERY);

  const blogSchemaProps: BlogSchemaProps = {
    id: `${process.env.GATSBY_SITE_URL}${pageContext.urlPath}`,
    headline: pageContext.title,
    description: pageContext.metaDescription,
    images: pageContext.images
  };

  useEffect(() => {
    // Inject carousel into diy/design-styles page
    const carouselMountPoints = document.querySelectorAll('[data-carousel-mount]');
    carouselMountPoints.forEach(mountPoint => {
      const carouselData = mountPoint.getAttribute('data-carousel-images');
      if (carouselData) {
        try {
          const images = JSON.parse(carouselData);
          ReactDOM.render(<DesignStylesCarousel images={images}/>, mountPoint);
        } catch (error) {
          console.error('Error parsing carousel data:', error);
        }
      }
    });

    //Inject typeform quiz into diy/design-styles page
    const typeformQuizMountPoint = document.getElementById('typeform-quiz-widget');
    if (typeformQuizMountPoint) {
      ReactDOM.render(<TypeformQuiz/>, typeformQuizMountPoint);
    }

    //Inject lever widget into careers page
    const careersMountPoint = document.getElementById('lever_component');
    if (careersMountPoint) {
      ReactDOM.render(<Careers/>, careersMountPoint);
    }
    
    //Inject wedding bundle products into wedding albums collection page
    const weddingBundlesMountPoint = document.getElementById('album-collection-products');
    if (weddingBundlesMountPoint) {
      const store = createStore();
      ReactDOM.render(
        <Provider store={store}>
          <WeddingBundles category={productCategory}/>
        </Provider>,
        weddingBundlesMountPoint
      );
    }
  }, [productCategory]);

  return (
    <GlobalLayout displayPromoBanner contentPage>
      <SEO title={pageContext.metaTitle} description={pageContext.metaDescription}/>
      <BlogSchema {...blogSchemaProps} />
      <ContentMetatags
        title={pageContext.metaTitle}
        description={pageContext.metaDescription}
        canonicalUrl={`${process.env.GATSBY_SITE_URL}${pageContext.urlPath}`}
      />
      <div className="cms-page-view">
        <div id="maincontent">
          <div className="columns">
            <div className="column main" dangerouslySetInnerHTML={{ __html: pageContext.content }}/>
          </div>
        </div>
      </div>
    </GlobalLayout>
  );
};

export default analyticsWrapper(withCart(ContentPage));
